var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPng({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7635_2424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.5C8.19375 0.5 7.125 1.56875 7.125 2.875V36.125C7.125 37.4313 8.19375 38.5 9.5 38.5H33.25C34.5562 38.5 35.625 37.4313 35.625 36.125V10L26.125 0.5H9.5Z",
    fill: "#E2E5E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 10H35.625L26.125 0.5V7.625C26.125 8.93125 27.1938 10 28.5 10Z",
    fill: "#B0B7BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.625 17.125L28.5 10H35.625V17.125Z",
    fill: "#CAD1D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.875 31.375C30.875 32.0281 30.3406 32.5625 29.6875 32.5625H3.5625C2.90938 32.5625 2.375 32.0281 2.375 31.375V19.5C2.375 18.8469 2.90938 18.3125 3.5625 18.3125H29.6875C30.3406 18.3125 30.875 18.8469 30.875 19.5V31.375Z",
    fill: "#A066AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88867 22.9995C6.88867 22.686 7.13448 22.3428 7.53348 22.3428H9.72798C10.9618 22.3428 12.0733 23.1693 12.0733 24.7546C12.0733 26.2556 10.9618 27.0904 9.72798 27.0904H8.1403V28.3444C8.1403 28.7636 7.87667 28.9999 7.53348 28.9999C7.21998 28.9999 6.88867 28.7636 6.88867 28.3444V22.9995ZM8.1403 23.5398V25.9041H9.7268C10.3621 25.9041 10.8656 25.3436 10.8656 24.7546C10.8656 24.0896 10.3621 23.5398 9.7268 23.5398H8.1403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2824 23.0945C13.2824 22.7513 13.3584 22.42 13.8524 22.42C14.1932 22.42 14.2704 22.5055 14.5257 22.7513L17.6679 26.6831V22.9995C17.6679 22.686 17.9422 22.3428 18.2664 22.3428C18.6084 22.3428 18.9397 22.686 18.9397 22.9995V28.3444C18.9397 28.7636 18.6832 28.9227 18.4362 28.9999C18.1049 28.9999 17.9422 28.9239 17.6679 28.6686L14.5257 24.6798V28.3456C14.5257 28.7648 14.2692 29.0011 13.9272 29.0011C13.5852 29.0011 13.2812 28.7648 13.2812 28.3456V23.0945H13.2824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.083 28.2697C25.4085 28.829 24.582 29.0677 23.7472 29.0677C21.7522 29.0677 20.3379 27.9277 20.3379 25.6679C20.3379 23.7501 21.8294 22.2598 23.8315 22.2598C24.582 22.2598 25.4073 22.5163 25.9963 23.0958C26.5758 23.6646 25.7398 24.5101 25.171 24.0078C24.8195 23.6646 24.3255 23.4093 23.8315 23.4093C22.6832 23.4093 21.5729 24.3296 21.5729 25.6679C21.5729 27.0739 22.5027 27.9277 23.7472 27.9277C24.3255 27.9277 24.8195 27.7567 25.171 27.5002V26.3341H23.7472C22.9017 26.3341 22.9872 25.1739 23.7472 25.1739H25.646C25.9975 25.1739 26.3193 25.4411 26.3193 25.7356V27.7579C26.3193 27.9277 26.2445 28.088 26.083 28.2697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6875 32.5625H7.125V33.75H29.6875C30.3406 33.75 30.875 33.2156 30.875 32.5625V31.375C30.875 32.0281 30.3406 32.5625 29.6875 32.5625Z",
    fill: "#CAD1D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7635_2424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.88f4c2dc36d75621cc1f563c1a4c2a78.svg";
export { ForwardRef as ReactComponent };